import AuthContainer from "./AuthContainer";

const LoginRequired = () => {

    return (
        <div className="page-content page-min-height login-required-container">
            {/*<AuthPopup />*/}
            <AuthContainer />
        </div>
    )

}

export default LoginRequired;
